import { media } from '@styles/mediaQuery';
import styled from 'styled-components';

export const Label2 = styled.label`
  font-weight: 500;
  display: flex;
  flex-direction: column;
  h5 {
    font-size: 14px;
    strong {
      color: red;
    }
  }
  label {
    margin: 0;
  }
  p {
    margin-bottom: 0;
    font-size: 12px;
    color: #555;
  }
  input,
  select {
    margin-top: 5px;
    background: #f8fcff;
    border: 1px solid #e9e9e9;
    border-radius: 4px;
    padding: 6px 13px;
  }

  ${media.mobile`
    h5 {
      font-size: 13px;
    }
    input,
    select {
      padding: 9px 12px;
      font-size: 13px;
    }
  `}
`;
